import { View } from '@lernetz/ts-lib';

import { ScoreQuizAnswer } from './ScoreQuizAnswer';
import { Slide } from './Slide';

import template from './ScoreQuizQuestion.html';


export class ScoreQuizQuestion extends Slide {

    public readonly answers: ScoreQuizAnswer[];
    public correctlyAnswered: boolean;
    public readonly text: string;

    constructor( dto: object ) {
        super({
            answers: [],
            correctlyAnswered: false,
            text: '',
            type: '-multiple-choice',
            ...dto,
        });

        for (const answer of this.answers) {
            answer.propertyChange.filter( property => property.name === 'selected' && answer.selected ).subscribe( () => this.onAnswerSelected(answer) );
            answer.propertyChange.subscribe( () => this.updateState() );
        }
        this.propertyChange.subscribe( () => this.updateState() );
    }

    onAnswerSelected( answer: ScoreQuizAnswer ) {
        for ( const a of this.answers ) {
            a.selected = a === answer;
        }
    }

    updateState() {
        this.hasInput = this.answers.some( a => a.selected );
        this.correctlyAnswered = this.answers.every( a => a.correctlyAnswered );
        for( const answer of this.answers ) {
            answer.evaluated = this.evaluated;
        }
    }
}

export class ScoreQuestionView extends View<ScoreQuizQuestion> {

    constructor() {
        super({ template });
    }
}
